// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseCard_container__65LDm","panel":"PurchaseCard_panel__H_gIO","title":"PurchaseCard_title__tn62X"};